export const FETCH_PRODUCTS = "FETCH_PRODUCTS";
export const FETCH_STORES = "FETCH_STORES";
export const REQUEST = "REQUEST";
export const ERROR = "ERROR";
export const LOGIN_ERROR = "LOGIN_ERROR";
export const SET_TOKEN = "SET_TOKEN";
export const SET_AUTH = "SET_AUTH";
export const SET_USERTYPE = "SET_USERTYPE";
export const LOGOUT = "LOGOUT";
